import { BaseValidationRuleResolver } from './BaseValidationRuleResolver';

export const verifierNotInPractitionersValidationRuleResolver: BaseValidationRuleResolver = (
  value,
  _rule,
  _prop,
  _path,
  context
) => {
  if (!value) return null;

  const practitioners = context.getValue(['lcaPractitioners']) as Array<{ userId?: string }> | null;
  if (!Array.isArray(practitioners) || practitioners.length === 0) return null;

  const isConflict = practitioners.some((p) => p.userId === value);
  return isConflict ? 'Verifier cannot be one of the LCA Practitioners' : null;
};
